import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import OffersSelect from "../modules/offers/OffersSelect";

function Public() {
  return (
    <div className="main-content">
      {/* Simple header */}
      <nav className="navbar navbar-expand-lg navbar-dark" style={{ background: 'linear-gradient(to right, #00C6FF, #0072FF)' }}>
        <div className="container">
          <a className="navbar-brand" href="/">
          {/* <img 
              src={require("assets/img/brand/nlf-logo.png")} 
              alt="NLF" 
              className="mr-2"
              style={{ height: '35px', transform: 'scale(3)', transformOrigin: 'left center' }}
            /> */}
            NLF
          </a>
          <span className="navbar-text ml-auto">
            Select Offers
          </span>
        </div>
      </nav>

      {/* Main content area */}
      <div className="container-fluid">
        <Routes>
          <Route path="select" element={<OffersSelect />} />
          <Route path="*" element={<Navigate to="select" replace />} />
        </Routes>
      </div>

      {/* Simple footer */}
      <footer className="bg-light py-4 mt-5 h-100vh ">
        <div className="container text-center">
          <p className="text-muted mb-0">
            © 2024 National Lending Fund. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Public;
